import { UserRoleBadge } from "./UserRoleBadge";
import { UserRoleBadgeEnum } from "../../Shared/Types/UserRoleBadgeEnum";
import { SupportUserIcon } from "../Icon/SupportUserIcon";
import { Stack } from "@mui/material";
import { TrustedUserIcon } from "../Icon/TrustedUserIcon";
import * as React from "react";
import {
    getUserJoinedStatusText,
    USER_ACTIVITY_STATUS,
} from "../Modals/GroupParticipantsModal/GroupParticipantsSearchHeader/ListItem/ListItemUserSearch";

export function UserRoleBadgeFactory({ roleBadge }: { roleBadge: string }) {
    const enumValue = getEnumKeyByEnumValue(roleBadge);

    switch (enumValue) {
        case UserRoleBadgeEnum.AMBASSADOR:
            return (
                <Stack
                    sx={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: "var(--community-color-moderate-orange)",
                        margin: "0 4px",
                    }}
                    alignItems="center"
                    flexDirection="row"
                    gap={"4px"}
                >
                    {getUserJoinedStatusText(USER_ACTIVITY_STATUS.AMBASSADOR)}
                </Stack>
            );
        case UserRoleBadgeEnum.INSIDER:
            return (
                <Stack
                    sx={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: "var(--community-color-light-steal-blue)",
                        margin: "0 4px",
                    }}
                    alignItems="center"
                    flexDirection="row"
                    gap={"4px"}
                >
                    <TrustedUserIcon />
                    <span>
                        {getUserJoinedStatusText(USER_ACTIVITY_STATUS.INSIDER)}
                    </span>
                </Stack>
            );
        case UserRoleBadgeEnum.SUPPORT:
            return (
                <Stack
                    sx={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: "var(--community-color-dark-blue)",
                        margin: "0 4px",
                    }}
                    alignItems="center"
                    flexDirection="row"
                    gap={"4px"}
                >
                    <SupportUserIcon
                        {...{
                            height: 12,
                            width: 12,
                        }}
                    />
                    <span>Support</span>
                </Stack>
            );
        case UserRoleBadgeEnum.ANBIETER:
            return (
                <UserRoleBadge
                    text={"Anbieter"}
                    color={"var(--community-color-secondary-text)"}
                    backgroundColor={"var(--community-color-dark-gray)"}
                />
            );
        case UserRoleBadgeEnum.TEST:
            return (
                <UserRoleBadge
                    text={"Test"}
                    color={"var(--community-color-snow-white)"}
                    backgroundColor={"var(--community-color-light-steal-blue)"}
                />
            );
    }
    return <></>;
}

function getEnumKeyByEnumValue(roleBadge: string): UserRoleBadgeEnum {
    const values = Object.values(UserRoleBadgeEnum);

    for (let i = 0; i < values.length; i++) {
        if (values[i] == roleBadge) {
            return UserRoleBadgeEnum[values[i]?.toUpperCase()];
        }
    }
    return UserRoleBadgeEnum.DEFAULT;
}
